import { render, staticRenderFns } from "./my-bonuses.vue?vue&type=template&id=540d6679&"
import script from "./my-bonuses.vue?vue&type=script&lang=js&"
export * from "./my-bonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports